import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Dashboard.scss';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';
import ColorPlate from './ColorPlate';
import { motion } from 'framer-motion';

const Dashboard = () => {
    const { currentUser } = useAuth();
    const [myPalettes, setMyPalettes] = useState([])
    const [loading, setLoading] = useState(false)
    const darkTheme = useTheme();
    const dark = {
        background: "#222831",
        color: "orange"
    }
    const darkShadow = {
        background: "#222831",
        color: "orange",
        borderRadius: "50px",
        boxShadow: '35px 35px 70px #1d222a, -35px -35px 70px #272e38'
    }

    useEffect(()=>{
        // axios.get(`https://blooming-depths-76471.herokuapp.com/mypalettes/${currentUser.uid}`)
        axios.get(`https://blooming-depths-76471.herokuapp.com/mypalettes/${currentUser.uid}`)
        .then(res => {
            setMyPalettes(res.data)
            setLoading(false);
        })
    },[currentUser.uid, loading])

    return (
        <div className="dashboard" style={(darkTheme) ? dark : null}>
            <motion.div
            initial={{scale: 0}}
            animate={{scale: 1}}
            className="dashboard__top" style={(darkTheme) ? darkShadow : null}>
                <h1 className="dashboard__head">My Palettes</h1>
                <div className="dashboard__top-right">
                    <h2 className="dashboard__title">Profile</h2>
                    <p className="dashboard__user">{currentUser.email}</p>
                </div>
            </motion.div>
            <div className="dashboard__palettes">
                {(!loading && myPalettes) ? myPalettes.map((pal, i) => {
                    return (
                    <motion.div
                    initial={{x: "-1000%"}}
                    animate={{x: "0"}}
                    transition={{duration: 0.5, delay: parseFloat(`0.${i}`)}}
                    >
                        <ColorPlate key={i} id={pal.palette_id} palette={pal} load={setLoading} darkTheme={darkTheme}/>
                    </motion.div>
                    )
                }) : null}
            </div>
        </div>
    )
}

export default Dashboard
